<template>
	<div :class="classObj" class="app-wrapper">
		<div v-if="device==='mobile'&&sidebar.opened" class="drawer-bg" @click="handleClickOutside" />
		<sidebar class="sidebar-container" style="min-width:100%!important;" v-on:top_hide="top_hide" />
		<viewleft class="sidebar-left" :style="this.top_change == true ? '':'margin-top:0px'"  :changeData="top_change"/>
		<div :class="classObj" style="height: 100%;background: white;">
			<div :class="{hasTagsView:needTagsView}" class="main-container" :style="this.top_change == true ? '':'margin-top:0px'">
				<div :class="{'fixed-header':fixedHeader}" style="position: fixed; width: 100%;z-index: 30;background-color: white;margin-top:-2px;">
					<!-- <navbar /> -->
					<tags-view v-if="needTagsView" />
				</div>
				<app-main style="margin-top:91px;" />
				<right-panel v-if="showSettings">
					<settings />
				</right-panel>
			</div>
		</div>
	</div>
</template>

<script>
	import {getToken} from '@/utils/auth'
	import {getTime,save,updateReaded,unread} from '@/api/im/message'
	import {getInfo} from '@/api/login'

	import RightPanel from '@/components/RightPanel'
	import {AppMain,Navbar,Settings,Sidebar,TagsView} from './components'
	import viewleft from "./components/Sidebar/viewleft.vue";
	import ResizeMixin from './mixin/ResizeHandler'
	import {mapState} from 'vuex'

	export default {
		name: 'Layout',
		components: {
			AppMain,
			Navbar,
			RightPanel,
			Settings,
			Sidebar,
			TagsView,
			viewleft

		},
		data() {
			return {
				socket: null,
				userId: null,
				top_change: false
			}
		},
		mounted() {
			getInfo().then(response => {
				this.userId = response.user.userId;
				this.$nextTick(() => {
					let header = {
						extraHeaders: {
							'Authorization': 'Bearer ' + getToken()
						}
					};

					/*注册socket.io*/
					//this.socket = io("http://192.168.1.150:8080/",header);
					this.socket = io("https://"+process.env.VUE_APP_BASE_IP+"/", header);
					/*用户上线后注册*/
					this.socket.on("conn_response", data => {
						if (data) {
							this.socket.emit("user_register", {
								id: this.userId,
                secure:true
							});
						}
					});

					var self_socket = this.socket;

					var self = this;


					layui.use('layim', function(layim) {


						/*设置token */
						layim.token = getToken();
						/*设置工程目录*/
						layim.baseUrl = process.env.VUE_APP_BASE_API

						/*收到用户在线*/
						self_socket.on("user_online", data => {
							layim.setFriendStatus(data.id, 'online');
						});

						/*收到用户离线*/
						self_socket.on("user_offline", data => {
							layim.setFriendStatus(data.id, 'offline');
						});

						/*接收用户消息*/
						self_socket.on("user_receive", data => {
							layim.getMessage(data["message"]);
							updateReaded(data.id)
						});
						//基础配置
						layim.config({
							title: '消息盒子',
							copyright:true,
							min: true,
							isgroup: false,
							init: {
								url: process.env.VUE_APP_BASE_API + '/ywpx/im/users?prefix=' + window.encodeURI(process.env.VUE_APP_BASE_IMG_URL) +
									'&default=' + window.encodeURI('/static/img/profile.png'),
								headers: {
									'Authorization': 'Bearer ' + getToken()
								}
							}
							//上传图片接口（返回的数据格式见下文），若不开启图片上传，剔除该项即可
							,
							uploadImage: {
								url: process.env.VUE_APP_BASE_API + '/ywpx/im/images/upload/' + window.encodeURI(process.env.VUE_APP_BASE_API +
										'&ywpx') //接口地址
									,
								type: 'post' //默认post
									,
								headers: {
									'Authorization': 'Bearer ' + getToken()
								}
							},
							uploadFile: {
								url: process.env.VUE_APP_BASE_API + '/ywpx/im/files/upload/' + window.encodeURI(process.env.VUE_APP_BASE_API +
										'&ywpx') //接口地址
									,
								type: 'post' //默认post
									,
								headers: {
									'Authorization': 'Bearer ' + getToken()
								}
							},
							chatLog: layui.cache.dir + 'css/modules/layim/html/chatlog.html' //聊天记录页面地址，若不开启，剔除该项即可
						});


						/*初始化完成*/

						layim.on('ready', function(options){
							layui.jquery.ajax({
								url:'/socket/status/',
								type:'get',
								dataType:'json',
								headers: {
									Accept: "application/json; charset=utf-8",
									Authorization: 'Bearer ' + getToken()
								},
								success:(resp)=>{
									for(let idx in resp){
										layim.setFriendStatus(resp[idx], 'online');
									}
								}
							});

							unread(self.userId).then(unreads=>{
								for(let i=0,len = unreads.length;i<len;i++){
									//alert(JSON.stringify(unreads[i]));
									layim.getMessage(unreads[i]);
								}
							});
						});


						/*发送消息处理*/
						layim.on('sendMessage', res => {
							getTime().then(time => {
								let mine = res.mine;
								let to = res.to;
								let source = mine.id;
								let target = to.id;
								let contents = {
									username: mine.username //消息来源用户名
										,
									avatar: mine.avatar //消息来源用户头像
										,
									id: mine.id //消息的来源ID（如果是私聊，则是用户id，如果是群聊，则是群组id）
										,
									type: to.type //聊天窗口来源类型，从发送消息传递的to里面获取
										,
									content: mine.content //消息内容
										//,cid: 0 //消息id，可不传。除非你要对消息进行一些操作（如撤回）
										,
									mine: false //是否我发送的消息，如果为true，则会显示在右方
										,
									fromid: mine.id //消息的发送者id（比如群组中的某个消息发送者），可用于自动解决浏览器多窗口时的一些问题
										,
									timestamp: time //服务端时间戳毫秒数。注意：如果你返回的是标准的 unix 时间戳，记得要 *1000
								}
								save(source, target, JSON.stringify(contents)).then(id => {
									let message = {
										id: id,
										target: target,
										source: source,
										message: contents
									};
									self_socket.emit("user_send_message", message)
								});
							})

						});
					});
				});
			});
		},
		mixins: [ResizeMixin],
		computed: {
			...mapState({
				sidebar: state => state.app.sidebar,
				device: state => state.app.device,
				showSettings: state => state.settings.showSettings,
				needTagsView: state => state.settings.tagsView,
				fixedHeader: state => state.settings.fixedHeader
			}),
			classObj() {
				return {
					hideSidebar: !this.sidebar.opened,
					openSidebar: this.sidebar.opened,
					withoutAnimation: this.sidebar.withoutAnimation,
					mobile: this.device === 'mobile'
				}
			}
		},
		methods: {
			handleClickOutside() {
				this.$store.dispatch('app/closeSideBar', {
					withoutAnimation: false
				})
			},
			top_hide: function(data) {
				this.top_change = data;
				console.log(data);
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import "~@/assets/styles/mixin.scss";
	@import "~@/assets/styles/variables.scss";

	.app-wrapper {
		@include clearfix;
		position: relative;
		height: 100%;
		width: 100%;
	}

	// 移动端默认展开左侧菜单，抽屉遮罩不再使用
	.mobile .drawer-bg {
		display: none;
	}

	.drawer-bg {
		background: #000;
		opacity: 0.3;
		width: 100%;
		top: 0;
		height: 100%;
		position: absolute;
		z-index: 999;
	}

	.fixed-header {
		position: fixed;
		top: 0;
		right: 0;
		z-index: 9;
		width: calc(100% - #{$sideBarWidth});
		transition: width 0.28s;
	}

	.hideSidebar .fixed-header {
		width: calc(100% - 54px)
	}

	.mobile .fixed-header {
		// 移动端左侧菜单宽150px，头部只占其右侧区域，避免白色背景盖住左侧菜单顶部
		width: calc(100% - 150px) !important;
	}
</style>
